import { GoogleLogin } from "@react-oauth/google";
import React, { useState } from 'react';
import googleLogo from "../../Assets/google-logo.png";
import "./SignUp.css";
import logo from "../../Assets/logo-update.png";
import Navbar from '../Navbar/Navbar';
import { toast } from 'react-toastify';
const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      console.log(data);

      if (res.ok) {
        toast.success("🎉 Signup successful!");
        // redirect or clear form
      } else {
          toast.error(data.message || "Signup failed");
      }
    } catch (err) {
      console.error(err);
       toast.error("Server error. Please try again.");
    }
  };
 const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const idToken = credentialResponse?.credential;
      const res = await fetch(`${API_BASE_URL}/api/auth/google`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ credential: idToken }),
      });

      const data = await res.json();

      if (!res.ok) {
        toast.error(data.message || "Google signup failed");
        return;
      }

      toast.success("🎉 Signed up successfully!");
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      // navigate wherever you want (dashboard/build chatbot/etc.)
      // navigate("/dashboard");
    } catch (err) {
      console.error(err);
      toast.error("Server error. Please try again.");
    }
  };
  return (
    <>
      <Navbar />
      <div className="signup-wrapper">
        <div className="signup-card">
          <img src={logo} alt="XenaChat Logo" className="logo-top" />
          <h2>Sign Up for Free. No Credit Card Required.</h2>
          <p className="subtitle">7-day free trial. No credit card needed.</p>

         <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => toast.error("Google sign-in failed")} />

          <div className="divider">
            <span>or</span>
          </div>

          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Full name</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="John Doe"
            />

            <label htmlFor="email">Business Email</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="johndoe@acme.com"
              maxLength="50"
              className='signUpEmail'
            />

            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="@xyz"
            />

            <button type="submit" className="signup-btn">
              Sign up with Email
            </button>
          </form>

          <p className="footer-login">
            Already have an account? <a href="/SignIn">Log In</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default SignUp;
